module.exports = __webpack_public_path__ + "static/media/phone_1.0876d510.png";